import { render, staticRenderFns } from "./no-password.vue?vue&type=template&id=2fcff8f2&"
import script from "@/model/nopassword?vue&type=script&lang=js&"
export * from "@/model/nopassword?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports